import React, { useState, useEffect } from 'react';
import { contactInfo } from '../../data/ultimateData';

const UltimateContact = () => {
 const [formData, setFormData] = useState({
 name: '',
 email: '',
 mobile1: '',
 mobile2: '',
 problem: ''
 });
 const [isSubmitting, setIsSubmitting] = useState(false);
 const [submitMessage, setSubmitMessage] = useState('');
 const [shapath, setShapath] = useState(false);
 const [alreadySubmitted, setAlreadySubmitted] = useState(false);
 const [callNumber, setCallNumber] = useState('');

 const API_URL = '';

 // Check if form was already submitted from this browser
 useEffect(() => {
 const submitted = localStorage.getItem('mata_maliha_form_submitted');
 if (submitted) {
 setAlreadySubmitted(true);
 setCallNumber(localStorage.getItem('maliha_call_number') || '');
 }
 }, []);

 const handleChange = (e) => {
 setFormData({ ...formData, [e.target.name]: e.target.value });
 };

 const handleSubmit = async (e) => {
 e.preventDefault();
 setIsSubmitting(true);
 setSubmitMessage('');

 if (typeof window.fbq === 'function') {
 window.fbq('track', 'InitiateCheckout', {
 content_name: 'Contact Form Submit',
 content_category: formData.problem,
 value: 0,
 currency: 'INR'
 });
 }

 try {
 const response = await fetch(`${API_URL}/api/contact`, {
 method: 'POST',
 headers: { 'Content-Type': 'application/json' },
 body: JSON.stringify(formData)
 });

 const data = await response.json();

 if (data.duplicate) {
 // Duplicate submission - already registered
 setSubmitMessage('आप पहले ही फॉर्म भर चुके हैं। नीचे दिए number पर WhatsApp से संपर्क करें।');
 setAlreadySubmitted(true);
 localStorage.setItem('mata_maliha_form_submitted', 'true');
 if (data.whatsapp_target) {
 localStorage.setItem('maliha_call_number', data.whatsapp_target);
 setCallNumber(data.whatsapp_target);
 }
 } else if (response.ok && data.id) {
 if (typeof window.fbq === 'function') {
 window.fbq('track', 'Lead', {
 content_name: 'Form Submitted',
 content_category: formData.problem
 });
 }
 // Mark as submitted in localStorage
 localStorage.setItem('mata_maliha_form_submitted', 'true');
 if (data.id) localStorage.setItem('maliha_lead_id', data.id);
 // Round-robin सेवा दल number पर details के साथ WhatsApp forward
 const num = data.whatsapp_target || '9973988635';
 localStorage.setItem('maliha_call_number', num);
 const waUrl = data.whatsapp_url || `https://api.whatsapp.com/send/?phone=91${num}`;
 localStorage.setItem('maliha_wa_url', waUrl);
 setCallNumber(num);
 setAlreadySubmitted(true);
 setIsSubmitting(false);
 window.location.href = waUrl;
 return;
 } else {
 setSubmitMessage('कुछ गलत हुआ। कृपया पुनः प्रयास करें।');
 }
 } catch (error) {
 setSubmitMessage('कुछ गलत हुआ। कृपया पुनः प्रयास करें।');
 }

 setIsSubmitting(false);
 };

 return (
 <section className="relative py-16 sm:py-24 overflow-hidden" data-testid="contact-section" id="contact-form-section" style={{ background: "linear-gradient(180deg, rgba(9,9,12,0.94) 0%, rgba(9,9,12,0.90) 50%, rgba(9,9,12,0.96) 100%), url('/img/815ed57f.webp') center/cover no-repeat fixed" }}>
 
 {/* Background Effects - Purple */}
 <div className="absolute inset-0">
 <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#0B0B0E] rounded-full blur-3xl" />
 <div className="absolute bottom-1/4 right-1/4 w-80 h-80 bg-[#0B0B0E] rounded-full blur-3xl" />
 </div>
 
 <div className="relative z-10 container mx-auto px-4 sm:px-6 lg:px-8">

 {/* Section Header */}
 <div className="text-center mb-12">
 <span className="inline-block tracking-[0.3em] text-[#C9A23A] font-bold text-sm mb-3 uppercase">
 जांच क्षमतानुसार दक्षिणा
 </span>
 <h2 className="text-3xl sm:text-4xl lg:text-5xl font-black mb-4" style={{ fontFamily: "'Rozha One', serif" }}>
 <span className="">
 अभी माता मलीहा की अर्जी लगाएं!
 </span>
 </h2>
 <p className="text-[#D8D2C6] text-lg max-w-2xl mx-auto">
 फॉर्म भरें और <span className="text-[#E2C170] font-bold">माता जी की कृपा</span> प्राप्त करें
 </p>
 <p className="text-[#F3EDE2] text-xl font-bold mt-4" style={{ fontFamily: "'Rozha One', serif" }}>
 पहले जांच, संतुष्ट हों तो क्षमतानुसार दक्षिणा - कोई जबरदस्ती नहीं
 </p>
 {/* Aghori Disclaimer */}
 <div className="mt-6 p-4 rounded-xl bg-[#17171C] border border-[#5c1a1a] max-w-2xl mx-auto">
 <p className="text-[#F3EDE2] font-bold text-sm">
 ❖ <span className="text-[#F3EDE2]">अघोर विधि</span> से कार्य होता है। पूरी श्रद्धा-विश्वास हो तभी आएं। <span className="text-[#F3EDE2]">जिन्हें विश्वास नहीं, दूर रहें।</span>
 </p>
 <p className="text-[#F3EDE2] font-bold text-sm mt-1">
 ! छल-कपट, दुर्भाव से ना आएं - <span className="text-[#E2C170]">अच्छे मन से आएं</span>
 </p>
 </div>
 </div>

 {/* Form Container */}
 <div className="max-w-2xl mx-auto">
 <div className="p-8 sm:p-10 rounded-2xl bg-gradient-to-br from-[#17171C] to-[#101014] border border-[#d4a84b]/60">
 
 {/* Already Submitted Message */}
 {alreadySubmitted && (
 <div className="mb-6 p-6 rounded-xl bg-[#250808] border border-[#C9A23A]/40 text-center" data-testid="form-success-box">
 <div className="text-5xl mb-4">✓</div>
 <h3 className="text-2xl font-bold text-[#E2C170] mb-2">आपका Form Submit हो गया है!</h3>
 <p className="text-[#D8D2C6] mb-4">
 अब WhatsApp पर सेवा दल से सीधे बात करें — आपकी details भेज दी गई हैं।
 </p>
 {callNumber && (
 <a href={localStorage.getItem('maliha_wa_url') || `https://api.whatsapp.com/send/?phone=91${callNumber}`} data-testid="call-sewa-dal-btn"
 className="inline-block w-full sm:w-auto px-8 py-4 rounded-xl font-black text-lg text-white bg-gradient-to-r from-[#1fa855] to-[#128C4A] shadow-lg hover:opacity-90 transition-opacity">
 💬 WhatsApp पर बात करें — +91 {callNumber}
 </a>
 )}
 <p className="text-[#F3EDE2] text-sm mt-4">
 ❖ जय माता मलिहा ❖
 </p>
 </div>
 )}
 
 {/* Show form only if not submitted */}
 {!alreadySubmitted && (
 <>
 {/* Trust Building - Why People Trust Us */}
 <div className="mb-6 p-4 rounded-xl bg-[#0B0B0E] border border-[#d4a84b]/30">
 <p className="text-[#F3EDE2] font-bold text-center mb-3 text-lg">
 ❖ लोग माता जी पर क्यों भरोसा करते हैं?
 </p>
 <div className="grid grid-cols-1 sm:grid-cols-2 gap-2 text-sm">
 <div className="flex items-center gap-2 p-2 rounded-lg bg-[#0B0B0E]">
 <span className="text-[#E2C170]">✓</span>
 <span className="text-[#F3EDE2]">परची देखते ही नाम बता देती हैं</span>
 </div>
 <div className="flex items-center gap-2 p-2 rounded-lg bg-[#0B0B0E]">
 <span className="text-[#E2C170]">✓</span>
 <span className="text-[#F3EDE2]">पहले जांच, फिर पैसा - धोखा नहीं</span>
 </div>
 <div className="flex items-center gap-2 p-2 rounded-lg bg-[#0B0B0E]">
 <span className="text-[#E2C170]">✓</span>
 <span className="text-[#F3EDE2]">50,000+ संतुष्ट भक्त देश-विदेश में</span>
 </div>
 <div className="flex items-center gap-2 p-2 rounded-lg bg-[#0B0B0E]">
 <span className="text-[#E2C170]">✓</span>
 <span className="text-[#F3EDE2]">25+ वर्षों का विश्वसनीय अनुभव</span>
 </div>
 </div>
 </div>

 {/* What Mata Ji Will Tell You */}
 <div className="mb-6 p-4 rounded-xl bg-[#250808] border border-[#C9A23A]/40">
 <p className="text-[#E2C170] font-bold text-center mb-2">
 ☎ सिर्फ नाम बताइए, माता जी खुद बता देंगी:
 </p>
 <div className="flex flex-wrap justify-center gap-2 text-sm">
 <span className="px-2 py-1 rounded bg-[#250808] text-[#E2C170]">समस्या का असली कारण</span>
 <span className="px-2 py-1 rounded bg-[#250808] text-[#E2C170]">समस्या देने वाला कौन</span>
 <span className="px-2 py-1 rounded bg-[#250808] text-[#E2C170]">आपके शहर/गाँव का नाम</span>
 </div>
 <p className="text-[#D8D2C6] text-xs text-center mt-2">
 ◈ अगर माता जी सही बताएं तभी आगे बढ़ें - कोई जबरदस्ती नहीं
 </p>
 </div>

 <form onSubmit={handleSubmit} className="space-y-6">
 
 {/* Name */}
 <div>
 <label className="block text-[#D8D2C6] text-sm font-bold mb-2">आपका नाम *</label>
 <input
 type="text"
 name="name"
 value={formData.name}
 onChange={handleChange}
 required
 className="w-full px-4 py-4 rounded-xl bg-[#17171C] border border-[#d4a84b]/60 text-[#D8D2C6] placeholder-amber-100/50 focus:border-[#d4a84b]/50 focus:outline-none transition-all text-lg"
 placeholder="अपना पूरा नाम लिखें"
 data-testid="form-name"
 />
 </div>

 {/* Email */}
 <div>
 <label className="block text-[#D8D2C6] text-sm font-bold mb-2">
 आपका Email * <span className="text-[#F3EDE2]">(Report यहीं आएगी)</span>
 </label>
 <input
 type="email"
 name="email"
 value={formData.email}
 onChange={handleChange}
 required
 className="w-full px-4 py-4 rounded-xl bg-[#17171C] border border-[#d4a84b]/60 text-[#D8D2C6] placeholder-amber-100/50 focus:border-[#d4a84b]/50 focus:outline-none transition-all text-lg"
 placeholder="example@gmail.com"
 data-testid="form-email"
 />
 <p className="text-[#F3EDE2]/70 text-xs mt-1">✉ आपकी समस्या की विस्तृत रिपोर्ट इसी email पर भेजी जाएगी</p>
 </div>

 {/* Primary Mobile */}
 <div>
 <label className="block text-[#D8D2C6] text-sm font-bold mb-2">
 प्राइमरी मोबाइल नंबर * <span className="text-[#F3EDE2]">(संपर्क)</span>
 </label>
 <input
 type="tel"
 name="mobile1"
 value={formData.mobile1}
 onChange={handleChange}
 required
 pattern="[0-9]{10}"
 className="w-full px-4 py-4 rounded-xl bg-[#17171C] border border-[#d4a84b]/60 text-[#D8D2C6] placeholder-amber-100/50 focus:border-[#d4a84b]/50 focus:outline-none transition-all text-lg"
 placeholder="पहला 10 अंकों का नंबर"
 data-testid="form-mobile1"
 />
 </div>

 {/* Secondary Mobile */}
 <div>
 <label className="block text-[#D8D2C6] text-sm font-bold mb-2">
 सेकेंडरी मोबाइल नंबर * <span className="text-[#7a2929]">(अलग नंबर)</span>
 </label>
 <input
 type="tel"
 name="mobile2"
 value={formData.mobile2}
 onChange={handleChange}
 required
 pattern="[0-9]{10}"
 className="w-full px-4 py-4 rounded-xl bg-[#17171C] border border-[#d4a84b]/60 text-[#D8D2C6] placeholder-amber-100/50 focus:border-[#d4a84b]/50 focus:outline-none transition-all text-lg"
 placeholder="दूसरा 10 अंकों का नंबर"
 data-testid="form-mobile2"
 />
 <p className="text-[#D8D2C6]/60 text-xs mt-1">दोनों नंबर देना अनिवार्य है</p>
 </div>

 {/* Problem - Text Area */}
 <div>
 <label className="block text-[#D8D2C6] text-sm font-bold mb-2">आपकी समस्या * <span className="text-[#F3EDE2]">(विस्तार से लिखें)</span></label>
 <textarea
 name="problem"
 value={formData.problem}
 onChange={handleChange}
 required
 rows={4}
 className="w-full px-4 py-4 rounded-xl bg-[#17171C] border border-[#d4a84b]/60 text-[#D8D2C6] placeholder-amber-100/50 focus:border-[#d4a84b]/50 focus:outline-none transition-all text-lg resize-none"
 placeholder="अपनी समस्या यहाँ विस्तार से लिखें... जैसे: पति से झगड़ा, नौकरी में परेशानी, कर्ज की समस्या, संतान नहीं हो रही, आदि"
 data-testid="form-problem-textarea"
 />
 <p className="text-[#D8D2C6]/60 text-xs mt-1">जितना विस्तार से लिखेंगे, उतना अच्छा समाधान मिलेगा</p>
 </div>

 {/* Mahakaal Shapath Checkbox */}
 <div className="p-4 rounded-xl bg-[#17171C] border-2 border-[#5c1a1a]">
 <label className="flex items-start gap-3 cursor-pointer">
 <input
 type="checkbox"
 checked={shapath}
 onChange={(e) => setShapath(e.target.checked)}
 required
 className="w-6 h-6 mt-1 rounded border-2 border-[#d4a84b] bg-red-950 text-[#7a2929] focus:ring-amber-500 focus:ring-2 flex-shrink-0"
 data-testid="shapath-checkbox"
 />
 <span className="text-[#F3EDE2] font-bold text-base leading-relaxed">
 ❖ मैं <span className="text-[#F3EDE2]">महाकाल की शपथ</span> खाता/खाती हूँ कि माता जी की जांच सही लगने पर <span className="text-[#E2C170]">क्षमतानुसार दक्षिणा श्रद्धापूर्वक अर्पित करूंगा/करूंगी।</span>
 </span>
 </label>
 <p className="text-[#F3EDE2] text-xs mt-2 ml-9">! शपथ लेना अनिवार्य है। झूठी शपथ लेने वालों को महाकाल क्षमा नहीं करते।</p>
 </div>

 {/* Submit Button */}
 <button
 type="submit"
 disabled={isSubmitting || !shapath}
 className="w-full py-5 bg-gradient-to-r from-[#f5d77e] via-[#d4a84b] to-[#d4a84b] hover:from-[#f5d77e] hover:via-amber-400 hover:to-[#f5d77e] text-black text-xl font-black rounded-xl shadow-xl shadow-amber-500/30 disabled:opacity-50 disabled:cursor-not-allowed transition-all transform hover:scale-[1.02]"
 data-testid="form-submit-btn"
 style={{ fontFamily: "'Rozha One', serif" }}
 >
 {isSubmitting ? 'भेज रहे हैं...' : 'माता जी से बात करें '}
 </button>

 {/* Submit Message */}
 {submitMessage && (
 <div className={`p-4 rounded-xl text-center ${submitMessage.includes('सफल') ? 'bg-[#250808] border border-[#C9A23A]/40 text-[#E2C170]' : 'bg-[#fff5f5] border border-[#5c1a1a] text-[#F3EDE2]'}`}>
 {submitMessage}
 </div>
 )}

 {/* Trust Badges */}
 <div className="flex flex-wrap justify-center gap-3 pt-4">
 <span className="px-3 py-1 rounded-full text-xs bg-[#250808] border border-[#C9A23A]/40 text-[#E2C170]">100% गोपनीय</span>
 <span className="px-3 py-1 rounded-full text-xs bg-[#0B0B0E] border border-[#d4a84b]/30 text-[#F3EDE2]">क्षमतानुसार दक्षिणा</span>
 <span className="px-3 py-1 rounded-full text-xs bg-[#0B0B0E] border border-[#d4a84b]/60 text-[#D8D2C6]">फॉर्म द्वारा</span>
 </div>
 </form>
 </>
 )}
 </div>
 </div>

 {/* WhatsApp Info */}
 <div className="text-center mt-10">
 <p className="text-[#D8D2C6]/80 text-sm">
 फॉर्म भरने के बाद माता जी की कृपा से हमारा सेवा-दल आपसे संपर्क करेगा
 </p>
 </div>
 </div>
 </section>
 );
};

export default UltimateContact;
